/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/

/** Represents a permission string used in access control operations.
 * Permissions define what actions a user or role is allowed to perform within an iTwin.
 */
export type Permission = string;